var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NebulaGridRow',{attrs:{"type":"flex"}},[_c('NebulaColumn',{attrs:{"columns":12}},[_c('NebulaBreadcrumbs',{attrs:{"aria-label":_vm.$t('breadcrumbs-aria', { ns: 'usermanagement' }),"breadcrumbs":_vm.breadcrumbs,"dropdownUseRouterLinks":"","showDimText":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }